InlineVariations = window.InlineVariations ?= {}
InlineVariations.Views ?= {}

InlineVariations.Views.Trait = Backbone.View.extend
  dropdownSelection: '.inline-variation-dropdown-selection'
  traitValues: '.inline-variation-trait-value'
  inlineTitleHtml: '.inline-variation-trait-title'
  body: 'body'

  touch:
    main: '.t-main'
    traitValuesContainer: '.inline-variation-trait-values'

  events:
    'click .inline-variation-dropdown-selection': 'toggleDropdown'
    'click .inline-variation-trait-value': 'traitValueSelection'

  webSwatchEvents:
    'mouseenter .inline-variation-trait-value': 'updateTitleToHoveredTrait'
    'mouseleave .inline-variation-trait-value': 'updateTitleToOriginalTrait'

  initialize: ->
    @layout = @model.get 'layout'
    @title = @model.get 'title'
    @isSwatchImageDropdown = @layout.isImageSwatch and @layout.isDropdown
    @isTouch = @options.isTouch

    @$body = $(@body)
    @$traitValues = @$el.find @traitValues

    if @layout.isDropdown
      @placeholderHtml = @model.get 'title'
      @placeholderValue = @model.get 'placeholderValue'
      @placeholderValueId = @model.get 'placeholderValueId'
      @$titleHtml = @$el.find @dropdownSelection
    else
      @$titleHtml = @$el.find @inlineTitleHtml

    if @layout.enableFilterSheet
      @$body = $(@touch.main)
      @$touchTraitValuesContainer = @$el.find @touch.traitValuesContainer

    @listenTo @model, 'change:selectedTraitValue', @setTraitValue

    _.extend @events, @webSwatchEvents if @layout.isSwatch and not (@isTouch or @isTouchDevice())

    @processTraitValues()

  isTouchDevice : ->
    'ontouchstart' of window or navigator.maxTouchPoints

  processTraitValues: ->
    for value in @model.get 'values'
      value.$el = @$el.find "##{value.id}"

  toggleDropdown: (e) ->
    isOpen = @$el.hasClass 'open'
    @model.collection.closeDropdowns()

    return if isOpen

    @model.collection.view.showBackdrop this
    @openTrait() unless @layout.enableFilterSheet

  slideDownAnimation: ->
    @$touchTraitValuesContainer.slideDown 400, =>
      @openTrait()

  openTrait: ->
    @$el.addClass 'open'
    @sendDropdownTrackingEvent false

  sendDropdownTrackingEvent: (isOpen) ->
    status = if isOpen then 'close' else 'open'
    OptimizeSuite.TrackingHub.add "inline-variations-dropdown-#{status}"

  closeDropdown: ->
    @$body.addClass 'stop-propagation' if @layout.enableFilterSheet
    return unless isOpen = @$el.hasClass 'open'

    if @layout.enableFilterSheet
      @$touchTraitValuesContainer.slideUp 400, =>
        @$el.removeClass 'open'
        @sendDropdownTrackingEvent isOpen
    else
      @$el.removeClass 'open'
      @sendDropdownTrackingEvent isOpen

  traitValueSelection: (e) ->
    $target = $(e.currentTarget)
    return e.stopPropagation() if $target.hasClass 'sold-out'

    @$body.addClass 'stop-propagation' if @layout.enableFilterSheet
    selected = $target.hasClass 'selected'
    return if selected and @layout.isDropdown and not (@layout.isSwatch or @isTouch)

    @$traitValues.removeClass 'selected'

    if selected
      @model.setSelectedTraitValueById()
    else
      @model.setSelectedTraitValueById $target.attr('id')

    @model.collection.view.render()

  updateTitleToHoveredTrait: (e) ->
    return unless @layout.isSwatch
    $target = $(e.currentTarget)
    return if $target.hasClass 'sold-out'

    if currentTraitValue = @model.getTraitValueById $target.attr('id')
      @$titleHtml.html currentTraitValue.selectedHtml

  updateTitleToOriginalTrait: (e) ->
    return unless @layout.isSwatch
    return if $(e.currentTarget).hasClass 'sold-out'

    @$titleHtml.html @model.get('selectedTraitValueHtml') or @title

  setTraitValue: ->
    @closeDropdown() unless @layout.enableFilterSheet
    selectedTraitValue = @model.get('selectedTraitValueHtml')
    selectedTraitValueId = @model.get('selectedTraitValueId')

    if @layout.isDropdown or @layout.isSwatch
      unless selectedTraitValue
        if @layout.isSwatch
          selectedTraitValue = @title
        else
          selectedTraitValue = @placeholderHtml
          selectedTraitValueId = @placeholderValueId

      @$titleHtml.html selectedTraitValue

    @$traitValues.each ->
      $traitValue = $(this)
      $traitValue.toggleClass 'selected', $traitValue.attr('id') is selectedTraitValueId

  showErrorMessages: ->
    @$el.addClass 'error' unless @model.get('selectedTraitValue')
    @$traitValuesContainer?.addClass 'error'

  hideErrorMessages: ->
    @$el.removeClass 'error'
    @$traitValuesContainer?.removeClass 'error'

  toggleSoldOut: (traitValue, isSoldOut) ->
    traitValue.$el.toggleClass 'sold-out' , isSoldOut

module.exports = InlineVariations.Views.Trait
